function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["tag", "type", "size", "level", "center", "ellipsis", "className", "children", "strong", "underline", "disabled", "renderType", "delete", "onClick"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useMemo } from "react";
import Ellipsis from "./Ellipsis";
import { isObject } from "@firefly/fly-defter";
import classNames from "classnames";
import { createNamespace } from "../context/create";
import { jsx as _jsx } from "react/jsx-runtime";
var _createNamespace = createNamespace('typography'),
  _createNamespace2 = _slicedToArray(_createNamespace, 1),
  bem = _createNamespace2[0];
var ellipsisDefaultValue = {
  rows: 1
};
var TypographyBase = function TypographyBase(_ref) {
  var _ref$tag = _ref.tag,
    tag = _ref$tag === void 0 ? 'div' : _ref$tag,
    type = _ref.type,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    _ref$level = _ref.level,
    level = _ref$level === void 0 ? 5 : _ref$level,
    center = _ref.center,
    ellipsis = _ref.ellipsis,
    className = _ref.className,
    children = _ref.children,
    strong = _ref.strong,
    underline = _ref.underline,
    disabled = _ref.disabled,
    renderType = _ref.renderType,
    del = _ref.delete,
    onClick = _ref.onClick,
    props = _objectWithoutProperties(_ref, _excluded);
  var internalClick = function internalClick(e) {
    if (disabled) {
      e.stopPropagation();
    }
    onClick === null || onClick === void 0 || onClick(e);
  };
  var ellipsisNumber = useMemo(function () {
    if (typeof ellipsis === 'boolean' && ellipsis) return 1;
    if (typeof ellipsis === 'number') return ellipsis;
    if (isObject(ellipsis) && ellipsis.rows) return ellipsis.rows;
    return 0;
  }, [ellipsis]);
  var isEllipsis = !!ellipsis;
  var isCssEllipsis = useMemo(function () {
    if (typeof ellipsis === 'boolean') return true;
    if (typeof ellipsis === 'number') return true;
    if (isObject(ellipsis)) {
      var p = _objectSpread(_objectSpread({}, ellipsisDefaultValue), ellipsis);
      if (!p.collapseText && !p.expandText && !p.suffixCount && !p.suffixText && !p.symbol) return true;
    }
    return false;
  }, [ellipsis]);
  var isEnhanceEllipsis = isEllipsis && !isCssEllipsis;
  var TagElement = useMemo(function () {
    if (renderType === 'title') {
      if (level === 1) return 'h1';
      if (level === 2) return 'h2';
      if (level === 3) return 'h3';
      if (level === 4) return 'h4';
      if (level === 5) return 'h5';
      return 'h6';
    }
    return tag;
  }, [tag]);
  var measureStyle = useMemo(function () {
    var propsStyle = _objectSpread(_objectSpread({}, props.style), {}, {
      '--fly-typography-color': props.color
    });
    if (isEllipsis && isCssEllipsis && ellipsisNumber > 1) {
      return _objectSpread(_objectSpread({}, propsStyle), {}, {
        '--line-clamp': ellipsisNumber
      });
    }
    return propsStyle;
  }, [props.style, isCssEllipsis]);
  var renderContent = function renderContent() {
    if (isEnhanceEllipsis) return /*#__PURE__*/_jsx(Ellipsis, _objectSpread(_objectSpread(_objectSpread({
      onContentClick: internalClick,
      className: classNames(className, bem(renderType), bem([type, size, _defineProperty({
        center: center,
        strong: strong,
        underline: underline,
        disabled: disabled,
        delete: del
      }, "l".concat(level), renderType === 'title' && level)]))
    }, props), ellipsis), {}, {
      style: measureStyle,
      children: children
    }));
    return /*#__PURE__*/_jsx(TagElement, _objectSpread(_objectSpread({
      className: classNames(className, bem(renderType), bem([type, size, _defineProperty({
        center: center,
        strong: strong,
        underline: underline,
        disabled: disabled,
        delete: del
      }, "l".concat(level), renderType === 'title' && level)]), _defineProperty({
        'fly-ellipsis': isEllipsis && isCssEllipsis && ellipsisNumber === 1
      }, "".concat(bem("ellipsis", ['multi'])), isEllipsis && isCssEllipsis && ellipsisNumber > 1))
    }, props), {}, {
      onClick: internalClick,
      style: measureStyle,
      children: children
    }));
  };
  return renderContent();
};
export default TypographyBase;